// extracted by mini-css-extract-plugin
export default {"itemCardRemoveBtn":"remove-icon-button__itemCardRemoveBtn___op_xu"};